import TableStaticColumnBody from 'components/Table/TableStatic/TableStaticColumnBody';
import {FC, ReactNode} from 'react';
import {useTableRowGroup} from 'react-aria';

type TableColumnBodyProps = {
    children: ReactNode;
};

const TableColumnBody: FC<TableColumnBodyProps> = ({children}) => {
    const {rowGroupProps} = useTableRowGroup();

    return (
        <TableStaticColumnBody {...rowGroupProps}>
            {children}
        </TableStaticColumnBody>
    );
};

export default TableColumnBody;
